/* eslint-disable */

import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState } from "react";

export default function DetailsGoogleSheetV2() {
  const { t: uiT } = useUiTranslation();
  const [buttonText, setButtonText] = useState("نسخ السكربت");
  const [copySuccess, setCopySuccess] = useState(false);

  // السكربت الذي سيتم نسخه
  const script = `var wbook = SpreadsheetApp.openByUrl('https://docs.google.com/spreadsheets/d/1FN2NSQ1vWb8IgM0TXEPJ7M5luluiluilif83V-Y5IPn8TEOBkbQI/edit?gid=0#gid=0')
var sheet = wbook.getSheetByName('Feuille 1');

function doPost(e) {
  try {
    var data = JSON.parse(e.postData.contents);

    var action = data.action;

    if (action === 'addUser') {
      return addUser(data);
    } else {
      return ContentService
        .createTextOutput(JSON.stringify({
          status: "error",
          message: "Action non reconnue: " + action
        }))
        .setMimeType(ContentService.MimeType.JSON);
    }
  } catch (error) {
    console.error("❌ Erreur dans doPost:", error);
    return ContentService
      .createTextOutput(JSON.stringify({
        status: "error",
        message: error.toString()
      }))
      .setMimeType(ContentService.MimeType.JSON);
  }
}

function addUser(data) {
  try {

    var name = data.name || "";
    var orderId = data.orderId || "";
    var product = data.product || "";
    var phone = data.phone || "";
    var state = data.state || "";
    var commune = data.commune || "";
    var address = data.address || "";
    var qty = Number(data.qty) || 0;
    var note = data.note || "";
    var sku = data.sku || "";
    var price = Number(data.price) || 0;
    var deleveryPrice = Number(data.deleveryPrice) || 0;
    var deleveryStatus = data.deleveryStatus || "";
    var total = Number(data.total) || 0;
    var options = data.options || "";
    var deliveryType = data.deliveryType || "";

    // Ajouter la ligne avec toutes les colonnes dans l'ordre
    var rowData = [
      new Date(), // Timestamp
      orderId,
      name,
      product,
      phone,
      state,
      commune,
      address,
      qty,
      note,
      sku,
      price,
      deleveryPrice,
      deleveryStatus,
      total,
      options,
      deliveryType
    ];


    sheet.appendRow(rowData);


    return ContentService
      .createTextOutput(JSON.stringify({
        status: "success",
        message: "Utilisateur ajouté avec succès",
        data: {
          timestamp: new Date(),
          orderId: orderId,
          name: name,
          product: product
        }
      }))
      .setMimeType(ContentService.MimeType.JSON);

  } catch (error) {
    console.error("❌ Erreur dans addUser:", error);
    return ContentService
      .createTextOutput(JSON.stringify({
        status: "error",
        message: error.toString()
      }))
      .setMimeType(ContentService.MimeType.JSON);
  }
}

// Fonction de test pour débugger
function testAddUser() {
  var testData = {
    action: "addUser",
    name: "Test User",
    orderId: "TEST123",
    product: "TEST PRODUCT",
    phone: "0123456789",
    state: "Test State",
    commune: "Test Commune",
    address: "Test Address",
    qty: 1,
    note: "Test note",
    sku: "TEST-SKU",
    price: 1200,
    deleveryPrice: 0,
    deleveryStatus: "20",
    total: 1200,
    options: "Test options",
    deliveryType: "home"
  };

  var result = addUser(testData);
}`;

  // دالة النسخ باستخدام خاصية Clipboard API
  const copyToClipboard = () => {
    // نتحقق إذا كانت واجهة navigator.clipboard متاحة
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(script)
        .then(() => {
          setButtonText("تم نسخ السكربت");
          setCopySuccess(true);
          // إعادة النص الأصلي بعد مرور 3 ثواني
          setTimeout(() => {
            setButtonText("نسخ السكربت");
            setCopySuccess(false);
          }, 3000);
        })
        .catch((err) => {
          console.log("فشل النسخ", err);
          setButtonText("فشل النسخ");
        });
    } else {
      // إذا كانت Clipboard API غير مدعومة، نستخدم طريقة تقليدية
      const textArea = document.createElement("textarea");
      textArea.value = script;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setButtonText("تم نسخ السكربت");
        setCopySuccess(true);
        setTimeout(() => {
          setButtonText("نسخ السكربت");
          setCopySuccess(false);
        }, 3000);
      } catch (err) {
        console.log("فشل النسخ", err);
        setButtonText("فشل النسخ");
      }
      document.body.removeChild(textArea);
    }
  };
  return (
    <div className="min-h-[420px] h-fit" dir="rtl">
      <section className="cta-sec relative max-w-screen-xl px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col md:flex-row">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              {uiT("ui.sheetIntegrationSummary")}
              <span className="text-[#9e68ba]">{uiT("servicePageDetails.upsell.highlight")}</span>
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              {uiT("services.google_sheet_description")}
            </p>
            <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4">
              <h4 className="font-medium text-[#9e68ba] mb-2">
                {uiT("services.key_features")}
              </h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {uiT("ui.sheetReceiveOrders")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {uiT("ui.sheetTeamSharing")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {uiT("ui.sheetTools")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {uiT("ui.sheetExport")}
                </li>
              </ul>
            </div>
            <a
              className="inline-flex items-center px-4 py-2 text-[#9e68ba] bg-[#fcf6ff] rounded-lg font-medium transition-colors hover:bg-[#faf1ff]"
              href="https://www.youtube.com/embed/P0a5VUYVF8Q?si=1zOvro7jMw5zrSZ2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 ml-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
              {uiT("services.watch_integration_video")}
            </a>
          </div>

          <div className="flex-1 mx-auto sm:w-9/12 lg:mt-0 h-fit lg:w-auto mr-2">
            <iframe
              className="video-youtube"
              src="https://www.youtube.com/embed/P0a5VUYVF8Q?si=1zOvro7jMw5zrSZ2"
              title={uiT("ui.youtubePlayer")}
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{ borderRadius: "20px" }}
            ></iframe>
          </div>
        </div>
      </section>
      <div className="bg-blue-50 rounded-xl p-3 mx-2 border border-blue-100 mb-6">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          <div className="items-start justify-between md:flex">
            <div>
              <h3 className="text-blue-800 text-xl font-bold items-center">
                {uiT("services.script_used_in_video")}
              </h3>
            </div>
            <div className="items-center gap-x-3 md:mt-0 sm:flex">
              <button
                onClick={copyToClipboard}
                className="px-6 py-2.5 bg-blue-800 hover:bg-blue-900 text-white font-medium rounded-lg transition-colors "
              >
                {uiT("services.copy_script")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
